/**
 * New case wizard taxonomies (MDRS-157, MEDirect 2.0 design).
 *
 * These are the referrer/provider-facing assessment types and specialties from
 * the design's "New case" wizard — distinct from the report-builder
 * `SERVICE_TYPES` (which drive template selection). The chosen assessment type is
 * stored on `Case.service_type` and the specialty on `Case.specialty`.
 */

export const ASSESSMENT_TYPES: string[] = [
  "Allied Health IME Assessment",
  "Combined Medical Examination",
  "Hearing Loss Assessment",
  "IIA - Impairment Assessment",
  "IME - Physical",
  "IME - Psychiatric",
  "IME Eligibility - Physical",
  "IME Eligibility - Psychiatric",
  "IME Work Capacity (130 Week) - Physical",
  "IME Work Capacity (130 Week) - Psychiatric",
  "Subsequent Examination",
  "Supplementary Report",
  "Worksite Visit - General Practitioner",
  "Worksite Visit - Specialist",
];

/** The six commonly-requested specialties surfaced as quick picks. */
export const COMMON_SPECIALTIES: string[] = [
  "Orthopaedic Surgery",
  "Psychiatry",
  "Occupational Medicine",
  "Neurology",
  "Pain Medicine",
  "Clinical Psychology",
];

/** Full specialty list behind "Other specialty". */
export const OTHER_SPECIALTIES: string[] = [
  "Cardiology",
  "Dermatology",
  "Endocrinology",
  "ENT Surgery",
  "Gastroenterology",
  "General Practice",
  "General Surgery",
  "Geriatric Medicine",
  "Neurosurgery",
  "Ophthalmology",
  "Plastic Surgery",
  "Respiratory Medicine",
  "Rheumatology",
  "Rehabilitation Medicine",
  "Sports Medicine",
  "Urology",
  "Vascular Surgery",
];
